import React from "react";
import "./Stay_Ahead.css";
import Orange_Round_Arrow_Btn from "../../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";

function Stay_Ahead() {
  return (
    <section className="Stay_Ahead">
      <div className="content_holder">
        <div className="text_holder">
          <h4>
            Stay Ahead With <br />
            <span>Our Latest & Greatest</span>
          </h4>
        </div>

        <div className="Stay_Ahead_btn_holder">
          <Orange_Round_Arrow_Btn btn_name="Enter Your Email" />
        </div>
      </div>
    </section>
  );
}

export default Stay_Ahead;
